package com.anjuros.website.templates.selection.components.contactform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.web.attributes.SelectAttrsScope
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.ResKeyType
import com.anjuros.website.templates.mix.util.TemplateMixRes
import com.anjuros.website.templates.selection.components.RichText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.styles.InputStyle
import com.anjuros.website.templates.selection.styles.MainButtonStyle
import com.anjuros.website.templates.template2.util.Template2Res
import com.anjuros.website.templates.template6.styles.CompanyColorVar
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.builders.InputAttrsScope
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import kotlin.time.Clock

@Composable
fun ContactForm(
    contactItemsList: List<ContactFormInfo>,
    isSticky: Boolean = false,
    isDemo:Boolean = false,
    showLabel:Boolean = true,
    spamProtectionBackgroundColor:CSSColorValue = Theme.OpacityPrimary2.rgb,
    spamProtectionColor:CSSColorValue = Theme.ShowcaseButton.rgb,
    spamShieldColor:String = "#1D365C",
    buttonColor:CSSColorValue = Theme.ShowcaseButton.rgb,
    onSuccess: () -> Unit = {}

) {
    LaunchedEffect(Unit) {

        if(!isDemo) {
           registerTurnstileCallback()
        }
    }

    val viewModel = remember(contactItemsList) {
        ContactFormViewModel(
            contactItemsList = contactItemsList,
            isDemo = isDemo
        )
    }
    val state = viewModel.contactFormState

    LaunchedEffect(state.value.isSuccess) {
        if (state.value.isSuccess == true) {
            onSuccess()
        }
    }

    Column(
        modifier = Modifier.fillMaxSize().maxWidth(500.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        state.value.contactItemsList.forEach { item ->
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.Start
            ) {
                InputView(
                    item = item,
                    buttonColor = buttonColor,
                    showLabel = showLabel,
                    onChange = {
                        viewModel.onContactItemChanged(
                            newItem = item,
                            text = it
                        )
                    }
                )
            }
        }

        Column(modifier = Modifier.fillMaxWidth()
            .margin(top=20.px),
            verticalArrangement = Arrangement.spacedBy(1.px),
            horizontalAlignment = Alignment.Start) {
            if(isDemo) {
                DemoSpamProtection(

                    backgroundColor = spamProtectionBackgroundColor,
                    spamProtectionColor = spamProtectionColor,
                    shieldColor = spamShieldColor )

            } else {
                Div(
                    attrs = Modifier.fillMaxWidth()
                        .id("turnstile-container")
                        .toAttrs()
                    {
                        classes("cf-turnstile")
                        attr("data-sitekey", SITE_KEY)
                        attr("data-callback", "onTurnstileSuccess")

                    }
                )
                state.value.spamValidationError?.let {
                    ErrorText(it)
                }
            }
        }
        Box(
            modifier = Modifier.fillMaxWidth()

                .backgroundColor(Colors.Transparent)
                .bottom(0.px)
                .thenIf(isSticky, Modifier.position(Position.Sticky)),
            contentAlignment = Alignment.Center
        ) {
            org.jetbrains.compose.web.dom.Button(
                attrs = MainButtonStyle.toModifier()
                    .margin(topBottom = 20.px)
                    .onClick { event ->
                        event.preventDefault()
                        viewModel.onSubmit()
                    }
                    .height(40.px)
                    .border(width = 0.px)
                    .borderRadius(5.px)
                    .boxShadow(
                        2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                    )
                    .backgroundColor(buttonColor)
                    .color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .toAttrs()
            ) {
                if (state.value.isLoading) {
                    Text(LocalText(ResKey.CONTACT_FORM_SENDING))
                } else {
                    val buttonText = if(isDemo){
                        ResKey.BUTTON_CONTACT_SUBMIT_DEMO
                    } else {
                        ResKey.BUTTON_CONTACT_SUBMIT
                    }
                    Text(LocalText(buttonText))
                }
            }
        }
        if (state.value.isSuccess == false) {
            ErrorText(ResKey.TEXT_CONTACT_FORM_ERROR)
        }
    }
}

@Composable
fun InputView(
    item: ContactFormInfo,
    showLabel: Boolean,
    buttonColor:CSSColorValue,
    onChange: (text: String) -> Unit
) {

    if(showLabel) {
        ContactLabel(
            item = item
        )
    } else {
       Box(modifier = Modifier.fillMaxWidth()
           .margin(top=5.px))
    }

    when (item.type) {
        ContactFormDetailsType.INPUT -> {
            Input(
                type = item.getAutofill(),
                attrs = item.getModifier(buttonColor).toAttrs() {
                    onInput { event ->
                        onChange(event.value)
                    }
                    value(item.inputText)
                }
            )
        }

        ContactFormDetailsType.TEXT_AREA -> {
            TextArea (
                attrs = item.getModifier(buttonColor).toAttrs() {
                    onInput { event ->
                        onChange(event.value)
                    }
                    value(item.inputText)
                }
            )
        }
        ContactFormDetailsType.DROP_DOWN -> {

            FormDropdown(
                selectedValue = item.inputText,
                attrs = item.getModifier(buttonColor).toAttrs {
                        onChange {
                            onChange(it.value?:"")
                        }
                    },
                selectItemsList = item.optionList,
                placeholder = item.placeholderText
            )

        }
    ContactFormDetailsType.DROP_DOWN_LINKED -> {

        LinkedDropDown(
            item = item,
            buttonColor = buttonColor,
            onChange = { onChange(it)}
        )

    }

        ContactFormDetailsType.DATE_PICKER -> {
            Input(
                type = InputType.Date,
                attrs = item.getModifier(buttonColor)
                    .fillMaxWidth(50.percent)
                    .thenIf(rememberBreakpoint()<=Breakpoint.LG, Modifier.fillMaxWidth(100.percent))

                    .toAttrs() {
                    onInput { event ->
                        onChange(event.value)
                    }
                    value(item.inputText)
                }
            )

        }

        ContactFormDetailsType.RADIO_BUTTON -> {
            FormRadioButtons(
                selectedValue = item.inputText,
                options = item.optionList,
                placeholder = item.labelText,
                onSelected = {onChange(it)}
            )
        }

        ContactFormDetailsType.TICK_BOX -> {
            FormCheckBoxButtons(
                selectedValue = item.inputText,
                options = item.optionList,
                onSelected = {onChange(it.onAddCheckBox(item.inputText))}
            )
        }
    }

    item.errorMessage?.let {
        ErrorText(
            text = it,
            name = item.labelText
        )
    }
}

@Composable
fun SuccessForm() {
    Image(
        modifier = Modifier.size(64.px)
            .objectFit(ObjectFit.ScaleDown),
        src = TemplateMixRes.Icon.success,
        alt = "success"
    )
}

@Composable
fun ContactLabel(item: ContactFormInfo){
    val requiredInfo = if (item.required) "*" else ""
    Label(
        attrs = Modifier
            .fillMaxWidth()
            .classNames("form-label")
            .margin(top = 10.px)
            .toAttrs(),
    ) {
        Text(value = LocalText(item.labelText) + requiredInfo)
    }
}

@Composable
fun ErrorText(text: ResKeyType, name: ResKeyType? = null) {
    val errorBase: String = LocalText(text)
    P(
        attrs = Modifier
            .fillMaxWidth()
            .padding(left = 2.px)
            .color(Colors.Red)
            .margin(topBottom = 0.px, leftRight = 4.px)
            .fontSize(12.px)
            .toAttrs()
    ) {
        Text(errorBase.replace("%s", LocalText(name)))
    }
}

@Composable
fun ContactFormInfo.getModifier(color: CSSColorValue): Modifier {
    val item = this
    val inputValue = LocalText(item.placeholderText)

    return InputStyle.toModifier()
        .setVariable(CompanyColorVar,color)
        .fillMaxWidth()
        .classNames("form-control")
        .margin(top = 5.px)
        .padding(10.px)
        .borderRadius(5.px)
        .fontSize(16.px)
        .backgroundColor(Theme.LighterGray.rgb)
        .boxShadow(0.px, 0.px, 0.px, 0.px, null)
        .thenIf(item.height!=null, Modifier.height(item.height?:0.px))
        .attrsModifier {
            attr("placeholder", inputValue)
            attr("name", item.nameText)
            attr("required", item.required.toString())
        }
}

@Composable
fun FormDropdown(
    selectedValue:String,
    attrs: SelectAttrsScope.()->Unit,
    selectItemsList: List<ResKeyType>,
    placeholder:ResKeyType,
    placeholder2:String = "",
    onSelected: (ResKeyType) -> Unit ={}
) {
    Select(
        attrs = attrs
    ) {

        Option(
            value = "",
            attrs = {
                if (selectedValue.isBlank()) {
                    selected()
                }
                disabled()
                hidden()
            }
        ) {
            Text(LocalText(placeholder)+placeholder2)
        }

        selectItemsList.forEachIndexed {index, option ->
            val optionText = LocalText(option).replace("%s",(index+1).toString())
            Option(value = optionText,
                    attrs = {
                if (optionText == selectedValue){
                    onSelected(option)
                    selected()}
            }
            ) {
                Text(optionText)
            }
        }
    }
}

@Composable
fun FormRadioButtons(
    selectedValue: String,
    options: List<ResKeyType>,
    placeholder: ResKeyType,
    onSelected: (String) -> Unit
) {
    options.forEachIndexed {index, option ->
        val optionText = LocalText(option).replace("%s",(index+1).toString())

        Label {
            val text = LocalText(placeholder)
            Input(
                type = InputType.Radio,
                attrs = {
                    name(text)
                    checked(selectedValue == optionText)

                    onChange {
                        onSelected(optionText)
                    }
                }
            )

            Text(" $optionText")
        }
    }
}

@Composable
fun FormCheckBoxButtons(
    selectedValue: String,
    options: List<ResKeyType>,
    onSelected: (String) -> Unit
) {
    Row(
        modifier = Modifier.margin(top = 10.px),
        horizontalArrangement = Arrangement.spacedBy(20.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        val chunkSize = options.getChunkSize()
        options.chunked(chunkSize).forEachIndexed { columnIndex,columnOptions ->
            Column(
                modifier = Modifier,
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.Start
            ) {
                columnOptions.forEachIndexed{index, option ->

                    val finalIndex = chunkSize*columnIndex+(index+1)
                    val optionText = LocalText(option).replace("%s",finalIndex.toString())

                    Label {

                        Input(
                            type = InputType.Checkbox,
                            attrs = {

                                checked(selectedValue
                                    .split(",")
                                    .any { it.trim() == optionText })
                                onChange {
                                    onSelected(optionText)
                                }
                            }
                        )

                        Text(" $optionText")
                    }
                }
            }
        }
    }
}

@Composable
fun LinkedDropDown(item: ContactFormInfo,
                   buttonColor: CSSColorValue,
                   onChange: (text: String) -> Unit){
    val list = item.linkedOptionList
    var selectedItem by remember { mutableStateOf<ResKeyType?>(null) }
    FormDropdown(
        selectedValue = item.inputText,
        attrs = item.getModifier(buttonColor).toAttrs {
            onChange {

                onChange(it.value?:"")
            }
        },
        selectItemsList = list.keys.toList(),
        placeholder = item.placeholderText,
        onSelected = {selectedItem=it}
    )

    if(selectedItem!=null && item.inputText.isNotEmpty()){

        val selectItemsList = list[selectedItem] ?: emptyList()
        if(selectItemsList.isNotEmpty()) {

            val mainSelect = LocalText(selectedItem)
            FormDropdown(
                selectedValue = extractValue(item.inputText) ?: "",
                attrs = item.getModifier(buttonColor)
                    .toAttrs {
                        onChange {
                            onChange(item.inputText + " (" + it.value + ")")
                        }
                    },
                selectItemsList = selectItemsList,
                placeholder = item.placeholderText,
                placeholder2 = " ${mainSelect.lowercase()}"
            )
        }
    }
}

@Composable
fun DemoSpamProtection(
    backgroundColor: CSSColorValue,
    spamProtectionColor:CSSColorValue,
    shieldColor:String
){
    Box(
        modifier = Modifier.fillMaxWidth()
            .borderRadius(5.px)
            .border(
                width = 1.px,
                color = Theme.OpacityPrimary2.rgb,
                style = LineStyle.Solid
            )
            .backgroundColor(backgroundColor)
    ) {

        Row(modifier = Modifier.fillMaxWidth()
            .padding(4.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start) {

            Box(modifier = Modifier.width(60.px)) {
                ShieldCheckIcon(modifier = Modifier.size(40.px).align(Alignment.Center),
                    color = shieldColor)
            }
            Column(
                modifier = Modifier,
                verticalArrangement = Arrangement.spacedBy(5.px),
                horizontalAlignment = Alignment.Start
            ) {
                P(
                    attrs = Modifier

                        .margin(topBottom = 0.px)
                        .color(spamProtectionColor)
                        .textDecorationLine(TextDecorationLine.None)
                        .textAlign(TextAlign.Start)
                        .fontStyle(FontStyle.Normal)
                        .fontWeight(FontWeight.Bold)
                        .fontSize(18.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.SPAM_PROTECTION_INFO_TITLE))

                }
                P(
                    attrs = Modifier
                        .margin(topBottom = 0.px)
                        .color(spamProtectionColor)
                        .textDecorationLine(TextDecorationLine.None)
                        .textAlign(TextAlign.Start)
                        .fontStyle(FontStyle.Normal)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.SPAM_PROTECTION_INFO_SUBTITLE))

                }
                P(
                    attrs = Modifier
                        .margin(topBottom = 0.px)
                        .color(spamProtectionColor)
                        .textDecorationLine(TextDecorationLine.None)
                        .textAlign(TextAlign.Start)
                        .fontStyle(FontStyle.Normal)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    RichText(LocalText(ResKey.SPAM_PROTECTION_INFO_LEARN_MORE),
                        linkColor = spamProtectionColor)

                }
            }
        }

    }
}

fun String.onAddCheckBox(input: String): String {
    val items = input.split(",")
        .map(String::trim)
        .filter(String::isNotEmpty)

    return if (this in items) {
        items.filter { it != this }
            .joinToString(", ")
    } else {
        (items + this)
            .joinToString(", ")
    }
}

@Composable
fun List<ResKeyType>.getChunkSize():Int{
    val breakpoint = rememberBreakpoint()
    if(breakpoint<=Breakpoint.MD){
        return this.size
    }
    return if(this.size<=6){
        this.size
    } else this.size/2
}

fun extractValue(text: String): String? {
    return Regex("""\((.*?)\)""")
        .find(text)
        ?.groupValues
        ?.get(1)
}

fun  ContactFormInfo.getAutofill(): InputType.InputTypeWithStringValue {

    return when(this.autoFill){
        ContactAutoFill.TEXT -> InputType.Text
        ContactAutoFill.EMAIL -> InputType.Email
        ContactAutoFill.PHONE -> InputType.Tel
    }
}

fun registerTurnstileCallback() {

    js("""
        window.turnstileToken = null;

        window.onTurnstileSuccess = function(token) {
            window.turnstileToken = token;
        };
    """)

    window.setTimeout({
        js("""
            if (window.turnstile) {
                turnstile.render('#turnstile-container', {
                    sitekey: '$SITE_KEY',
                    callback: window.onTurnstileSuccess
                });
            }
        """)
    }, 100)
}

@Composable
fun ShieldCheckIcon(
    modifier: Modifier,
    color: String
) {
    Svg(
        attrs = modifier
            .toAttrs {
                attr("width", "24")
                attr("height", "24")
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("xmlns", "http://www.w3.org/2000/svg")
            }
    ) {
        Path(
            attrs = Modifier.toAttrs {
                attr(
                    "d",
                    "M9 12L11 14L15 10M20.618 5.984C17.4561 6.15192 14.3567 5.05861 12 2.944C9.64327 5.05861 6.5439 6.15192 3.382 5.984C3.12754 6.96911 2.99918 7.98255 3 9C3 14.591 6.824 19.29 12 20.622C17.176 19.29 21 14.592 21 9C21 7.958 20.867 6.948 20.618 5.984"
                )
                attr("stroke", color)
                attr("stroke-width", "1")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("fill", "none")
            }
        )
    }
}
